import HistoryScreen from "app/screens/residents/show/HistoryScreen";

export default function ResidentHistoryPage() {
  return <HistoryScreen />;
}
